export class PlacementOnCanvas {
  constructor(
    public x: number,
    public y: number,
    public width: number,
    public height: number,
  ) {}
}

/** @deprecated Use `PlacementOnCanvas` (PascalCase class) instead. */
export type placementOnCanvas = PlacementOnCanvas;
